// common/features/competition/wizard/constants.ts
import type {
  CloneCompetitionType,
  CloneTeamsMode,
  CompetitionType,
  JoinType,
  StructureType,
  WizardFormValues,
} from './types'

export const initialWizardValues: WizardFormValues = {
  creationMethod: null,
  cloneSource: {
    sourceScheduleId: null,
    sourceName: null,
    name: '',
    startsAt: null,
    endsAt: null,
    competitionType: null,
    isTournament: false,
    isRegistrationSchedule: false,
    cloneRegistrationSettings: false,
    cloneTeams: 'none',
  },
  info: {
    sportId: null,
    sportType: null,
    genericSportId: null,
    name: '',
    startsAt: null,
    endsAt: null,
    email: '',
    website: '',
  },
  // Step 3 Format pre-selects "Season" (first option) so the Next button is
  // immediately actionable; user can still pick a different card.
  competitionType: 'season',
  isTournament: false,
  // Step 4 Structure pre-selects "Single Division" for the same reason.
  structureType: 'single',
  divisions: [],
  conferences: [],
  joinType: null,
}

export const COMPETITION_TYPE_OPTIONS: ReadonlyArray<{
  value: CompetitionType
  label: string
  description: string
}> = [
  {
    value: 'season',
    label: 'Season',
    description: 'Regular season play with standings',
  },
  {
    value: 'playoffs_enhanced',
    label: 'Playoffs',
    description: 'Enhanced brackets with automated progressions',
  },
  {
    value: 'playoffs_simple',
    label: 'Simple Playoffs',
    description: 'Import or create your own schedule (flexible)',
  },
  {
    value: 'tournament',
    label: 'Tournament',
    description: 'Import or create your own tournament (flexible)',
  },
]

export const STRUCTURE_TYPE_OPTIONS: ReadonlyArray<{
  value: StructureType
  label: string
  description: string
}> = [
  {
    value: 'single',
    label: 'Single Division',
    description: 'All teams play in a single group or table.',
  },
  {
    value: 'multiple',
    label: 'Multiple Divisions',
    description: 'Organize teams into age groups or skill levels.',
  },
  {
    value: 'conferences',
    label: 'Conferences & Divisions',
    description: 'Dealing with larger seasons.',
  },
]

export const JOIN_TYPE_OPTIONS: ReadonlyArray<{
  value: JoinType
  label: string
  description: string
}> = [
  {
    value: 'registration',
    label: 'Registration / Payments',
    description:
      'Automate sign-ups by having teams or players register and take payments online.',
  },
  {
    value: 'manual',
    label: 'Manually Add / Import',
    description:
      'Invite Team Managers to add Players, or import teams and rosters in one file.',
  },
]

export const CLONE_COMPETITION_TYPE_OPTIONS: ReadonlyArray<{
  value: CloneCompetitionType
  label: string
  description: string
}> = COMPETITION_TYPE_OPTIONS

export const CLONE_TEAMS_OPTIONS: ReadonlyArray<{
  value: CloneTeamsMode
  label: string
}> = [
  { value: 'none', label: 'Don’t clone any teams' },
  { value: 'empty', label: 'Clone teams with empty rosters' },
  { value: 'full', label: 'Clone teams with full rosters' },
]

export const VALID_CLONE_COMPETITION_TYPES: readonly CloneCompetitionType[] = [
  'season',
  'playoffs_simple',
  'playoffs_enhanced',
  'tournament',
]
